'use client'
import FilterSearchBar from '@/components/map/components/filterSearchBar/view'
import NaverMap from '@/components/map/components/naverMap/view'
import useMapViewModel from '@/components/map/components/viewModel'

import type { ParkinglotDetail, SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import Shared from '@/shared'
import MapFooter from '@/shared/components/MapFooter'
import Portal from '@/shared/components/Portal'
import SlideBanner from '@/shared/components/SlideBanner'
import Toast from '@/shared/components/Toast'

import type { PARKINGLOT_TYPE } from '@/enums/detail'

export interface MapViewProps {
  // search place location
  searchLat?: string
  searchLng?: string
  // pin
  pin?: ParkinglotDetail | SharedParkinglotDetail
  id?: string
  type?: PARKINGLOT_TYPE
  // location of pin
  lat?: number
  lng?: number
  // display app env
  appEnv?: string
}

export default function MapView(props: MapViewProps) {
  const { texts, states, setters } = useMapViewModel({ ...props })
  const { isAirportBannerClosed } = Shared.States.useStorageStore()
  return (
    <>
      <FilterSearchBar appEnv={props.appEnv} isFilterOn={states.isFilterOn} setIsFilterOn={setters.setIsFilterOn} />
      <NaverMap
        width={`100%`}
        height={`100%`}
        lat={states.location.default.lat}
        lng={states.location.default.lng}
        setLocation={setters.setLocation}
        pins={states.pins}
        pin={props.pin}
        searchLat={props.searchLat}
        searchLng={props.searchLng}
        id={props.id}
        type={props.type}
        isFilterOn={states.isFilterOn}
        zoomLevel={states.zoomLevel}
        setIsFilterOn={setters.setIsFilterOn}
        setZoomLevel={setters.setZoomLevel}
      />
      {!isAirportBannerClosed && (
        <div className="absolute bottom-[28px] z-20 w-full px-4">
          <SlideBanner />
        </div>
      )}
      <div className="absolute bottom-0 left-0 z-20 flex w-full flex-col">
        <MapFooter />
      </div>

      {states.isErrorOnCurrPos && (
        <Portal targetId="#layer1">
          <Toast text={states.errorOnCurrPosText} onClose={() => setters.setIsErrorOnCurrPos(false)} />
        </Portal>
      )}
      {states.isErrorOnDataLoad && (
        <Portal targetId="#layer1">
          <Toast text={texts.errorOnDataLoadText} onClose={() => {}} />
        </Portal>
      )}
    </>
  )
}
